export type PaymentFlow = 'add-card' | 'charging'

export function getPaymentFlow(path: string): PaymentFlow | undefined {
  if (path === '/payments/add-card/landing') return 'add-card'
  if (path === '/payments/charging/landing') return 'charging'
  return undefined
}

const apps = {
  dev: { name: 'Stuart Energy' },
  prod: { name: 'Stuart Energy' },
  devwl: { name: 'Stuart White Label' },
  judu: { name: 'JUDU EV' },
} as const

// Decode once and count aliases such as payment_%72eference as the same key.
// Unrelated query fields are never copied to the app link.
function singleValue(search: string, name: string): string | undefined {
  const values: string[] = []
  for (const field of search.replace(/^\?/, '').split('&')) {
    const separator = field.indexOf('=')
    const key = separator < 0 ? field : field.slice(0, separator)
    try {
      if (decodeURIComponent(key.replace(/\+/g, ' ')) !== name) continue
    } catch {
      continue
    }
    try {
      values.push(decodeURIComponent((separator < 0 ? '' : field.slice(separator + 1)).replace(/\+/g, ' ')))
    } catch {
      return undefined
    }
  }
  return values.length === 1 ? values[0] : undefined
}

export function getReturnLink(
  search: string,
  flow: PaymentFlow = 'add-card'
): { appName: string; href: string } | undefined {
  const app = singleValue(search, 'app')
  if (app !== 'dev' && app !== 'prod' && app !== 'devwl' && app !== 'judu') return undefined

  const reference = singleValue(search, 'payment_reference')
  // Match the backend's 255-character bound without assuming a hex-only ID.
  // Reject control characters in untrusted URL data.
  // eslint-disable-next-line no-control-regex
  if (!reference || reference.length > 255 || /[\s\x00-\x1f\x7f-\x9f]/.test(reference)) return undefined

  return {
    appName: apps[app].name,
    href: `https://well-known.stuart.energy/${app}/payments/${flow}/return?payment_reference=${encodeURIComponent(
      reference
    )}`,
  }
}
